import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["alert", "hamburger", "hideHamburger"];

  connect() {
    if((window.screen.width < 1200) && (this.getCookie("leftNav") == "hide")) {
      this.hideMenu();
    }
  }

  close() {
    this.alertTargets.forEach(target => {
      target.remove();
      target.remove();
    });
  }

  hideShowMenu() {
    if(this.hamburgerTarget.classList.contains("hide")) {
      this.hideMenu();
    } else {
      this.showMenu();
    }
  }

  hideMenu(){
    var sideNav = document.getElementById("main-side-nav");
    var mainDiv = document.getElementsByTagName("main")[0];
    this.hamburgerTarget.classList.remove("hide");
    this.hideHamburgerTarget.classList.add("hide");
    sideNav.classList.add("hide")
    mainDiv.classList.remove("col-10");
    this.setCookie("leftNav", "hide");

  }

  showMenu(){
    var sideNav = document.getElementById("main-side-nav");
    var mainDiv = document.getElementsByTagName("main")[0];
    this.hamburgerTarget.classList.add("hide");
    this.hideHamburgerTarget.classList.remove("hide");
    sideNav.classList.remove("hide")
    mainDiv.classList.add("col-10");
    this.deleteCookie("leftNav", "/");

  }

  // Todo Move this somewhere else

  setCookie(name, value, days = 1, path = '/') {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path
  }

  getCookie(name) {
    return document.cookie.split('; ').reduce((r, v) => {
      const parts = v.split('=')
      return parts[0] === name ? decodeURIComponent(parts[1]) : r
    }, '')
  }

  deleteCookie(name, path) {
    this.setCookie(name, '', -1, path)
  }

}
